import React from "react";

import { faArrowAltCircleUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { BookSalesCallButton, FeatureInfo, type FeatureValues } from "./utils";

import styles from "./css/PaywallContent2023Q4.module.css";

type Feature = (typeof FeatureInfo)[FeatureValues];

export function PaywallContent2034Q4({
	className,
	featureKey,
	analyticsProperties,
	override,
}: {
	featureKey: FeatureValues;
	analyticsProperties: Record<string, unknown>;
	className?: string;
	override?: Partial<Feature>;
}) {
	const feature: Feature = React.useMemo(() => {
		const value = FeatureInfo[featureKey];
		if (!override) {
			return value;
		}
		return { ...value, ...override };
	}, [featureKey, override]);
	return (
		<div className={cx(styles.paywall, className)}>
			<div>
				<FontAwesomeIcon className={styles.paywallIcon} icon={faArrowAltCircleUp} />
			</div>
			<div className={styles.paywallHeading}>
				Upgrade to unlock <strong>{feature.title}</strong>
			</div>
			<p className={styles.description}>{feature.description}</p>
			<div className={styles.buttonContainer}>
				<BookSalesCallButton
					size="wide"
					feature={featureKey}
					analyticsProperties={analyticsProperties}
					className={styles.button}
				>
					Book time to chat
				</BookSalesCallButton>
			</div>
		</div>
	);
}
